var map = {
	"./aapl.svg": 81645,
	"./amzn.svg": 48521,
	"./bidu.svg": 68601,
	"./googl.svg": 26913,
	"./intc.svg": 14273,
	"./msft.svg": 14181,
	"./ntes.svg": 5161,
	"./nvda.svg": 82614,
	"./shel.svg": 98625,
	"./spcx.png": 79113,
	"./tsla.svg": 95737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65373;